import Extend from 'flarum/common/extenders';
import Translation from './models/Translation';
export default [new Extend.Store() //
.add('translations', Translation)];